(function () {
    'use strict';

    angular.module("imApp").factory("categoryLinkAddService", ['$ihttp', function ($ihttp) {
        let service = {
            listNotLinked: function (parms) {
                return $ihttp.post({
                    method: 631,
                    parameters: parms || {}
                });
            },
            saveLink: function (edit) {
                return $ihttp.post({
                    method: 632,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
